import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
// import logo from '../../../assets/imgs/logo.png';
// import logowhite from '../../../assets/imgs/Xtegrity-white-logo.png';
import { Icons } from '../../../../../assets/imgs/icons';
/**Imported for form validation */
import { useFormik } from 'formik';
import { resetPasswordInitialValues, resetPasswordSchema } from '../../../Extras/AuthenticationFormik';
import showToast from '../../../../../Shared/Utils/ToastNotification';
import Service from '../services/Service';
import { useSelector } from 'react-redux';
import Slider from '../../../Components/Slider';

const ResetPassword = () => {
  // show/hide password toggles
  const [showPass, setShowPass] = useState(false);
  const [showCPass, setShowCPass] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isLoading = useSelector((state) => state.loader.resetPassword);

  // Extract uid and token from query params
  const searchParams = new URLSearchParams(location.search);
  const uid = searchParams.get('uid');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!uid || !token) {
      showToast('info', 'Please check email for the reset link');
      navigate('/');
    }
  }, [uid, token, navigate]);

  const formik = useFormik({
    initialValues: resetPasswordInitialValues,
    validationSchema: resetPasswordSchema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      try {
        const payload = {
          uid,
          token,
          new_password: values.newPassword,
          confirm_password: values.confirmPassword,
        };
        const response = await Service.resetPassword(payload);

        if (response?.data) {
          showToast('success', response?.data?.detail || 'Password reset successfully! Please login.');
          navigate('/');
        } else {
          showToast('error', response?.data?.detail || 'Failed to reset password');
        }
      } catch (err) {
        // showToast('error', 'Something went wrong. Please try again.');
      }
    },
  });

  // helper to show an error message under fields
  const error = (name) => (formik.touched[name] && formik.errors[name] ? <div className="error">{formik.errors[name]}</div> : null);
  return (
    <>
      <div className="login">
        <div className="login-form loginpage">
          <div className="login-head">
            {/* <Link className="logo">
              <img src={logo} alt="" />
              <img src={logowhite} alt="" className="darkthemelogo" />
            </Link> */}
          </div>
          <div className="login-head-cont">
            <h2>Reset Your Password?</h2>
            <p>Enter your new password below.Make sure it’s strong and secure.</p>
          </div>

          <form onSubmit={formik.handleSubmit} noValidate>
            <div className="form-group pass">
              <label>
                New Password <span className="require">*</span>
              </label>
              <input
                className={`form-control${error('newPassword') ? ' is-invalid' : ''}`}
                type={showPass ? 'text' : 'password'}
                placeholder="**************"
                name="newPassword"
                value={formik.values.newPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={formik.isSubmitting}
              />
              {/* Toggle icon */}
              <button type="button" className="eye-toggle" onClick={() => setShowPass(!showPass)}>
                {showPass ? <Icons.EyeOpen className="eye open" /> : <Icons.EyeClose className="eye close" />}
              </button>
              {error('newPassword')}
            </div>
            <div className="form-group pass">
              <label>
                Confirm Password <span className="require">*</span>
              </label>
              <input
                className={`form-control${error('confirmPassword') ? ' is-invalid' : ''}`}
                type={showCPass ? 'text' : 'password'}
                placeholder="**************"
                name="confirmPassword"
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={formik.isSubmitting}
              />
              {/* <Icons.EyeClose className="eye close" /> */}
              <button type="button" className="eye-toggle" onClick={() => setShowCPass(!showCPass)}>
                {showCPass ? <Icons.EyeOpen className="eye open" /> : <Icons.EyeClose className="eye close" />}
              </button>
              {error('confirmPassword')}
            </div>

            <button className="btn" type="submit" disabled={formik.isSubmitting || !formik.isValid || isLoading}>
              {isLoading ? 'Updating...' : 'Update Password'}
              {/* Update Password */}
            </button>

            <div className="login-foot">
              <div className="login-link">
                Remembered your password? <Link to="/">Login</Link>
              </div>
            </div>
          </form>
        </div>
        <div className="login-content">
          <Slider type="resetPass" />
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
